import * as React from 'react';
import './style.scss';
import cx from 'classnames';
import StRcln from '@magaele/st_rcln/components/forSearchPanel';
import { isMobile } from '@libs/globalVariables';

interface ISessionProps {
    // defaultValue: string | undefined;
    sessionPicked: string;
    option: { text: string; value: string }[];
    itemClick: (idx: number) => void;
    icon?: JSX.Element[];
    onChangeCallBack?: (value: string) => void;
    isGDS: boolean;
    disabledSessions?: string[];
}
const Session: React.FC<ISessionProps> = (props) => {
    // console.log('Session', props);
    const {
        option,
        sessionPicked,
        itemClick,
        // defaultValue,
        icon,
        onChangeCallBack,
        isGDS,
        disabledSessions,
    } = props;
    // 確認場次是為固定時間還是區間
    const isRangeSession = ((option, isGDS) => {
        if (!isGDS) return false; // 自建商品PC版都不用下拉選單 TODO: 二階待確認
        const isRange = option.filter((item) => item.value.split('|')[0].indexOf('-') !== -1);
        if (isRange.length !== 0) return true;
        return false;
    })(option, isGDS);

    // 下拉選單props
    const dropdownProps = {
        defaultValue: sessionPicked,
        option,
        icon,
        onChangeCallBack,
    };

    const renderPC = () => {
        return isRangeSession ? (
            <StRcln {...dropdownProps} />
        ) : (
            <div className="sessions">
                {option &&
                    option.map((item, idx) => {
                        if (item.value === '') return <></>;
                        return (
                            <div
                                key={idx}
                                className={cx('session', {
                                    disabled: disabledSessions
                                        ? disabledSessions.includes(item.value)
                                        : false,
                                    active: sessionPicked === item.value,
                                })}
                                onClick={() => itemClick(idx)}
                            >
                                {item.text}
                            </div>
                        );
                    })}
            </div>
        );
    };
    const renderM = () => {
        return <StRcln {...dropdownProps} />;
    };

    return <div className="sessionComponent">{isMobile ? renderM() : renderPC()}</div>;
};

export default Session;
